const menu = $(".menu-drawer-container");
const openDetailsElement = $("details[open]");
const summaryElement = $(".menu-drawer-container[open]>summary");

if ($(window).width() < 480 || $(window).height() < 480) {
  $(".open-drawer").on("click", () => {
    menu
      .toggleClass("menu-opening")
      .promise()
      .done(() => {});
    menu.attr("open", "");
    summaryElement.attr("aria-expanded", true);
    document.body.classList.add('overflow-hidden-tablet');
    summaryElement.focus();
    $(".css-a2263j").css({
      display: "flex",
    });
  });

  $(".close-drawer").on("click", () => {
    $(".css-a2263j").css({
      display: "none",
    });
  });
}

$(".css-1fwmwm2 > p").click(function () {
  var openDrawerClass = $(this).toggleClass("css-lwv17d");
  var openDrawerFinalClass = $(this).attr("class");
  var icon = $(".header__icon--menu");
  menu
    .toggleClass("menu-opening")
    .promise()
    .done(() => {});
  menu.attr("open", "");
  icon.attr("aria-expanded", true);
  summaryElement.attr("aria-expanded", true);
  document.body.classList.add('overflow-hidden-tablet');
  summaryElement.focus();
  $(".css-a2263j").css({
    display: "flex",
  });
  $("." + openDrawerFinalClass).each(function () {
    $(this).attr("aria-expanded", true);
    $(this).parent().attr("open", "");
    $(this).parent().toggleClass("menu-opening");
  });
});

$(".open-search").on("click", () => {
  menu
    .toggleClass("menu-opening")
    .promise()
    .done(() => {});
  menu.attr("open", "");
  summaryElement.attr("aria-expanded", true);
  document.body.classList.add('overflow-hidden-tablet');
  summaryElement.focus();
  $(".css-a2263j").css({
    display: "flex",
  });
  $(".css-oawf44").focus();
});

document.addEventListener('DOMContentLoaded', function() {
  var detailsElements = document.querySelectorAll('header-menu > details');
  var headerOverlay = document.getElementById('Header-Overlay');
  
  detailsElements.forEach(function(details) {
    details.addEventListener('click', function() {
      if (this.hasAttribute('open')) {
        headerOverlay.style.display = 'block';
        headerOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      } else {
        headerOverlay.style.display = 'none';
      }
    });
  });
});